import {create} from 'zustand';
import {AccountInfoItem} from './types';
import {listActiveAccounts} from './ApiHelper';

export interface AccountState {
  loading: boolean;
  activeAccounts: AccountInfoItem[];
  hasErrors: boolean;
  refresh: (query?: string, force?: boolean) => void;
  reset(): void;
}

const UseActiveAccountStore = create<AccountState>((set) => {
  return {
    loading: true,
    activeAccounts: [],
    hasErrors: false,
    refresh: async (query?: string, force?: boolean) => {
      set(() => ({loading: true}));
      try {
        const activeAccounts = await listActiveAccounts(query);
        set(() => ({activeAccounts, loading: false, hasErrors: false}));
      } catch (err: any) {
        set(() => ({activeAccounts: [], loading: false, hasErrors: true}));
        throw err;
      }
    },
    reset: () => {
      set(() => ({
        loading: false,
        activeAccounts: [],
        hasErrors: false,
      }));
    },
  };
});

export default UseActiveAccountStore;
